import { getNodeDataRecord } from '../graph/nodeDefs.js';
import type { GraphNode } from '../graph/nodeDefs.js';
import {
  createNodeFieldRow,
  createNodeFieldTextInput,
  createNodeValueLabel,
} from './nodeFieldEditorControls.js';
import type { NodeFieldRenderDeps } from './nodeRenderers.js';

export function appendExposeAndName(
  node: GraphNode,
  container: HTMLElement,
  deps: NodeFieldRenderDeps,
): void {
  const data = getNodeDataRecord(node);
  const exposeRow = createNodeFieldRow();
  exposeRow.classList.add('value-row--toggle');
  const exposeLabel = document.createElement('label');
  exposeLabel.className = 'value-toggle';
  const exposeToggle = document.createElement('input');
  exposeToggle.type = 'checkbox';
  exposeToggle.checked = Boolean(data.exposed);
  exposeToggle.addEventListener('mousedown', e => e.stopPropagation());
  exposeToggle.addEventListener('change', () => {
    deps.commands.setValueExposed(node.id, exposeToggle.checked);
    deps.updateParams();
    deps.renderGraph();
    deps.scheduleRender();
  });
  const exposeText = document.createElement('span');
  exposeText.textContent = 'Expose';
  exposeLabel.appendChild(exposeToggle);
  exposeLabel.appendChild(exposeText);
  exposeRow.appendChild(exposeLabel);
  container.appendChild(exposeRow);

  const nameRow = createNodeFieldRow();
  nameRow.appendChild(createNodeValueLabel('Name'));
  nameRow.appendChild(createNodeFieldTextInput(String(data.name ?? ''), value => {
    deps.commands.setValueName(node.id, value);
    deps.updateParams();
    deps.scheduleRender();
  }));
  container.appendChild(nameRow);
}

export function appendOutputPort(
  node: GraphNode,
  portType: string,
  container: HTMLElement,
  deps: NodeFieldRenderDeps,
): void {
  const lastRow = container.lastElementChild as HTMLElement;
  const dot = document.createElement('div');
  dot.className = `port-dot out type-${portType}`;
  dot.dataset.node = node.id;
  dot.dataset.port = '0';
  dot.dataset.io = 'out';
  lastRow.appendChild(dot);
  deps.setupPortDrag(dot);
}
